export default __webpack_public_path__ + "static/sectorSur-ffd5bfb0047db86a0133f4246beb236b.webp";